import React, { useState } from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const Testimonials = () => {
  const [ref, inView] = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });

  const testimonials = [
    {
      quote:
        "Digify.world transformed our online presence. Our website traffic increased by 300% in just 3 months!",
      author: "James Wilson",
      company: "Wilson & Co.",
    },
    {
      quote:
        "The social media strategy they developed for us resulted in our best quarter ever. Highly recommended!",
      author: "Lisa Thompson",
      company: "Thompson Designs",
    },
    {
      quote:
        "Their SEO expertise helped us rank #1 for our main keywords. The results speak for themselves.",
      author: "Robert Garcia",
      company: "Garcia Enterprises",
    },
  ];

  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  const nextTestimonial = () => {
    setCurrentTestimonial((prev) =>
      prev === testimonials.length - 1 ? 0 : prev + 1
    );
  };

  const prevTestimonial = () => {
    setCurrentTestimonial((prev) =>
      prev === 0 ? testimonials.length - 1 : prev - 1
    );
  };

  return (
    <section id="testimonials" className="testimonials" ref={ref}>
      <div className="container">
        <h2 className="section-title">Client Testimonials</h2>

        <motion.div
          className="testimonial-container"
          initial={{ opacity: 0 }}
          animate={inView ? { opacity: 1 } : {}}
          transition={{ duration: 0.8 }}
        >
          <div className="testimonial-nav">
            <button onClick={prevTestimonial} className="nav-btn">
              ←
            </button>
            <button onClick={nextTestimonial} className="nav-btn">
              →
            </button>
          </div>

          <motion.div
            key={currentTestimonial}
            className="testimonial-card"
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -50 }}
            transition={{ duration: 0.5 }}
          >
            <p className="quote">"{testimonials[currentTestimonial].quote}"</p>
            <div className="author-info">
              <p className="author">
                {testimonials[currentTestimonial].author}
              </p>
              <p className="company">
                {testimonials[currentTestimonial].company}
              </p>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default Testimonials;
